export default __webpack_public_path__ + "img/sagoo/sagoo_logo.svg";